import React from "react";
import { FiInbox } from "react-icons/fi";

const EmptyState = ({
  icon: Icon = FiInbox,
  title = "Nothing here yet",
  description,
  action,
  className = "",
}) => {
  return (
    <div
      className={`flex flex-col items-center justify-center text-center px-6 py-12 rounded-2xl border-2 border-dashed border-line bg-subtle/60 ${className}`}
    >
      <div className="w-14 h-14 rounded-2xl bg-brandSoft flex items-center justify-center mb-4">
        <Icon className="text-main" size={26} aria-hidden="true" />
      </div>
      <p className="font-bold text-ink text-base">{title}</p>
      {description && (
        <p className="text-sm text-muted mt-1 max-w-md">{description}</p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
};

export default EmptyState;
